<template>
  <div
    style="background-color: rgb(245, 245, 245); width: 1200px; margin: 0 auto"
  >
    <Title
      :title="{ name: '部门管理', path: '/system/sysDept' }"
      :button-array="buttonArray"
      @openSaveOrEdit="openSaveOrEdit(1)"
    ></Title>
    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table
          :data="deptData"
          :header-cell-style="{
            background: 'rgb(245,245,245)',
            color: 'black',
          }"
          :cell-style="{ color: 'black' }"
          row-key="deptId"
          lazy
          :load="loadChildrenDept"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column fixed prop="deptName" label="部门名字" align="left">
          </el-table-column>
          <el-table-column label="部门管理员" prop="manageName" width="180" />
          <el-table-column label="部门描述" prop="description" />
          <el-table-column label="部门邮箱" prop="email" width="180" />
          <el-table-column label="创建时间" prop="createTime" width="180" />
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <el-row>
                <el-col :span="12">
                  <el-button
                    type="text"
                    size="small"
                    STYLE="color: black;"
                    @click="openSaveOrEdit(2, scope.row)"
                    >编辑</el-button
                  >
                </el-col>
                <el-col :span="12">
                  <el-popconfirm
                    title="确定删除该部门吗？"
                    @confirm="deleteSysdept(scope.row)"
                  >
                    <el-button
                      slot="reference"
                      type="text"
                      size="small"
                      STYLE="color: black;"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>

      </el-card>
    </div>

    <el-dialog
      :title="dialogTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="640px"
    >
      <deptEdit
        :dept-form="deptForm"
        :deptArrList="deptArrList"
        @closeWindow="closeWindow"
      ></deptEdit>
    </el-dialog>
  </div>
</template>

<script>
import Title from "../../Title";
import deptEdit from "./DeptEdit";
import {
  requestGetDeptTreeGrid,
  requestDeleteSysDept,
  requestGetChildrenDept,
  requestGetSysDeptTree,
} from "../../../api";
export default {
  name: "Sysdept",
  components: { Title, deptEdit },
  data() {
    return {
      deptForm: {
        deptName: "",
        chargeUser: "",
        parentId: "",
        description: "",
        email: "",
        needAudit: 1,
        parentArr: [],
      },
      deptData: [],
      dialogVisible: false,
      dialogTitle: "新增部门",
      buttonArray: [
        {
          type: "success",
          title: "新增部门",
          method: "openSaveOrEdit",
          disabled: false,
        },
      ],
      deptArrList: [],
    };
  },
  methods: {
    async getAllSysdept() {
      const response = await requestGetDeptTreeGrid();
      if (response.code == 200) {
        this.deptData = [response.object];
      } else {
        this.$message.error(response.message);
      }
    },
    async deleteSysdept(row) {
      let param = { deptId: row.deptId };
      const response = await requestDeleteSysDept(param);
      if (response.code == 200) {
        this.$message.success(response.msg);
        window.location.reload();
      } else {
        this.$message.error(response.msg);
      }
    },
    openSaveOrEdit(type, dept) {
      this.dialogTitle = "新增部门";
      if (type == 2) {
        this.dialogTitle = "编辑部门";
        this.deptForm = JSON.parse(JSON.stringify(dept));
        if (this.deptForm.parentArr != null) {
          this.showOrNo(
            this.deptArrList,
            JSON.parse(JSON.stringify(this.deptForm.parentArr))
          );
          let parentArr = this.deptForm.parentArr.split(",");
          this.deptForm.parentArr = [];
          parentArr.forEach((item) => {
            this.deptForm.parentArr.push(Number(item));
          });
        }
      }
      this.dialogVisible = true;
    },
    showOrNo(deptArrList) {
      deptArrList.forEach((item) => {
        if (
          this.deptForm.deptId == item.deptId ||
          (item.parentArr != undefined &&
            item.parentArr != null &&
            item.parentArr.indexOf(String(this.deptForm.deptId)) != -1)
        ) {
          item.show = true;
        } else {
          item.show = false;
        }
        if (item.children.length > 0) {
          this.showOrNo(item.children);
        }
      });
    },
    closeWindow(type) {
      this.dialogVisible = false;
      this.deptForm = {
        deptName: "",
        chargeUser: "",
        parentId: "",
        description: "",
        email: "",
      };
      if (Number(type) != 2) {
        window.location.reload();
      }
    },
    async loadChildrenDept(tree, treeMode, resolve) {
      let param = { parentId: tree.deptId };
      let response = await requestGetChildrenDept(param);
      if (response.code == 200) {
        resolve(response.object);
      } else {
        this.$message("获取子部门失败");
      }
    },
    getAllSysDeptTree() {
      requestGetSysDeptTree().then((res) => {
        if (res.code == 200) {
          this.deptArrList = [res.object];
        } else {
          this.$message.error("获取部门列表失败");
        }
      });
    },
  },
  created() {
    this.getAllSysdept();
    this.getAllSysDeptTree();
  },
};
</script>

<style scoped></style>
